import React, { useState, useRef } from "react";
import { Row, Col, Container } from "react-bootstrap";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";

import NotesHeader from "../../components/Applications/notes/NotesHeader";
import NotesSidebar from "../../components/Applications/notes/NotesSidebar";
import NotesCard from "../../components/Applications/notes/NotesCard";
import DeleteModal from "../../components/modals/notes/DeleteModal";
import ViewNoteModal from "../../components/modals/notes/ViewNoteModal";
import NotesCardHeader from "../../components/Applications/notes/NotesCardHeader";
import EditModal from "../../components/modals/notes/EditModal";

const NotesPage = () => {
  const [activeTab, setActiveTab] = useState("all");
  const [showDelete, setShowDelete] = useState(false);
  const [showView, setShowView] = useState(false);
  const [edit, setEdit] = useState(false);

  const sliderRef = useRef();

  const scrollLeft = () => {
    sliderRef.current.scrollBy({ left: -320, behavior: "smooth" });
  };

  const scrollRight = () => {
    sliderRef.current.scrollBy({ left: 320, behavior: "smooth" });
  };

  const notes = [
    {
      title: "Improve touch typing",
      date: "22 Jan 2024",
      desc: "Well, the way they make shows is, they make one show.",
      priority: "Low",
      tag: "Work",
      img: "/assets/img/profiles/avatar-02-1.jpg",
      deleted: false,
    },
    {
      title: "Learn calligraphy",
      date: "24 Jan 2024",
      desc: "Calligraphy, the art of beautiful handwriting.",
      priority: "Low",
      tag: "Social",
      img: "/assets/img/profiles/avatar-03.jpg",
      deleted: false,
    },
    {
      title: "Plan a trip to another country",
      date: "25 Jan 2024",
      desc: "Space, the final frontier.",
      priority: "Medium",
      tag: "Personal",
      img: "/assets/img/profiles/avatar-01-1.jpg",
      deleted: false,
    },
    {
      title: "Backup Files EOD",
      date: "20 Jan 2024",
      desc: "Project files backup before end of day.",
      priority: "High",
      tag: "Personal",
      img: "/assets/img/profiles/avatar-05.jpg",
      deleted: false,
    },
    {
      title: "Download Server Logs",
      date: "25 Jan 2024",
      desc: "Server log contains record of activity.",
      priority: "Low",
      tag: "Work",
      img: "/assets/img/profiles/avatar-06-1.jpg",
      deleted: true,
    },
    {
      title: "Team meet at Starbucks",
      date: "26 Jan 2024",
      desc: "Meeting at Starbucks.",
      priority: "Medium",
      tag: "Social",
      img: "/assets/img/profiles/avatar-07-1.jpg",
      deleted: false,
    },
  ];

  const getFilteredNotes = () => {
    switch (activeTab) {
      case "important":
        return notes.filter(
          (note) => note.priority === "High" && !note.deleted,
        );
      case "trash":
        return notes.filter((note) => note.deleted);
      case "all":
      default:
        return notes.filter((note) => !note.deleted);
    }
  };

  const filteredNotes = getFilteredNotes();

  return (
    <Container fluid className="notes-page">
      <NotesHeader />

      <Row>
        {/* SIDEBAR */}
        <Col xl={3}>
          <NotesSidebar activeTab={activeTab} setActiveTab={setActiveTab} />
        </Col>

        {/* RIGHT CONTENT */}
        <Col xl={9}>
          {/* IMPORTANT NOTES */}
          <div className="important-section">
            <NotesCardHeader />
            <div className="important-header">
              <div className="d-flex align-items-center gap-2">
                <h5>
                  {activeTab === "all"
                    ? "All Notes"
                    : activeTab === "important"
                      ? "Important Notes"
                      : "Trash"}
                </h5>

                <button className="arrow-btn" onClick={scrollLeft}>
                  <FaChevronLeft />
                </button>

                <button className="arrow-btn" onClick={scrollRight}>
                  <FaChevronRight />
                </button>
              </div>

              <div className="close-text">✕ Close</div>
            </div>

            <div className="important-slider" ref={sliderRef}>
              {filteredNotes.map((note, i) => (
                <div className="slider-card" key={i}>
                  <NotesCard
                    note={note}
                    onEdit={() => setEdit(true)}
                    onDelete={() => setShowDelete(true)}
                    onView={() => setShowView(true)}
                  />
                </div>
              ))}
            </div>
          </div>

          {/* DIVIDER */}
          <hr className="section-divider" />

          {/* GRID CARDS */}
          <Row>
            {filteredNotes.map((note, i) => (
              <Col md={4} key={i} className="d-flex">
                <NotesCard
                  note={note}
                  onDelete={() => setShowDelete(true)}
                  onView={() => setShowView(true)}
                />
              </Col>
            ))}
          </Row>
        </Col>
      </Row>

      <DeleteModal show={showDelete} handleClose={() => setShowDelete(false)} />
      <EditModal show={edit} handleClose={() => setEdit(false)} />

      <ViewNoteModal show={showView} handleClose={() => setShowView(false)} />

      {/* CSS */}
      <style>{`
        .notes-page {
          background: #f8f9fa;
          padding: 15px;
        }

        /* IMPORTANT HEADER */
        .important-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 15px;
        }

        .arrow-btn {
          border: 1px solid #ddd;
          background: #fff;
          border-radius: 50%;
          width: 28px;
          height: 28px;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .close-text {
          color: red;
          font-size: 14px;
        }

        /* SLIDER */
        .important-slider {
          display: flex;
          gap: 16px;
          overflow-x: auto;
          scroll-behavior: smooth;
        }

        .important-slider::-webkit-scrollbar {
          display: none;
        }

        .slider-card {
          min-width: 300px;
         
        }

        /* DIVIDER */
        .section-divider {
          margin: 25px 0;
          border-top: 1px solid #e5e7eb;
        }

        /* GRID GAP */
        .row {
          row-gap: 20px;
        }

        /* CARD */
        .note-card {
          width: 100%;
          background: #fff;
          border-radius: 12px;
          padding: 20px;
          border: 1px solid #eee;
        }

        /* 3 DOT */
        .menu-toggle svg {
          color: #111 !important;
        }

        @media (max-width: 768px) {
          .slider-card {
            min-width: 250px;
          }
        }
      `}</style>
    </Container>
  );
};

export default NotesPage;
